import { useDispatch } from 'react-redux';
import { RouterProvider as Provider } from 'react-router-dom';

import { routes } from '@/router';
import { transformElegantRouteToReactRoute } from '@/router/common/transform';
import { PlatformAccountService } from '@/service/api/platform/index';
import type { MenuItemDto } from '@/service/api/platform/menu';
import { store } from '@/store';

import { getUserInfo } from '../auth';
import { getIsLogin, setPermissions } from '../auth/authStore';

import { isAlreadyPatch, setIsAlreadyPatch } from './routeStore';
import { router } from './router';
import { RouterContext } from './router-context';

interface InheritAttrs {
  sideShow?: boolean;
}
const routerDataHander = (treeList: MenuItemDto[], inheritAttrs: InheritAttrs = {}) => {
  const newTreeList: Router.RouterData[] = [];
  treeList.forEach(tree => {
    const newTree: Router.RouterData = {
      component: tree.component,
      errorBoundary: tree.errorBoundary,
      fallback: tree.fallback,
      handle: {
        activeMenu: tree.activeMenu,
        hideInMenu: inheritAttrs.sideShow === false ? true : !tree.sideShow,
        icon: tree.icon,
        title: tree.name
      },
      name: tree.mark,
      path: tree.pagePath,
      redirect: tree.redirect,
      type: tree.menuType
    };
    if (tree.children && tree.children.length) {
      newTree.children = routerDataHander(tree.children, {
        sideShow: !newTree.handle!.hideInMenu
      });
    }
    newTreeList.push(newTree);
  });
  return newTreeList;
};
const InitRoutes = () => {
  const dispatch = useDispatch();
  useMount(async () => {
    if (getIsLogin(store.getState()) && !isAlreadyPatch()) {
      try {
        store.dispatch(setIsAlreadyPatch(true));
        await getUserInfo();
        const { data } = await PlatformAccountService.getMenus();
        const newMenus = routerDataHander(data!.menuList);
        dispatch(setPermissions(data!.permissionsList));
        router.reactRouter.patchRoutes(
          'root',
          newMenus.flatMap(route => transformElegantRouteToReactRoute(routes[0], route))
        );
      } finally {
        //
      }
    }
  });
  return <Outlet />;
};
// eslint-disable-next-line prettier/prettier
export const RouterProvider = () => {
  return (
    <RouterContext.Provider value={router}>
      <Provider router={router.reactRouter}>
        <InitRoutes />
      </Provider>
    </RouterContext.Provider>
  );
};
